import React from "react";
import styled from "styled-components"
import { EColor, EIconGlyph, ESize } from "../../styleConstants";
import { EIcon } from "../GUI";
import { breakPoint, rem } from "../styleUtils";
import ContentWrapper from "./contentWrapper";
import Icon from "./icon";
import SectionWrapper from "./sectionWrapper";

const USPWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${rem(20)};

    flex-wrap: wrap;
`

const USPTitle = styled.div`
    margin-left: ${rem(ESize.extra_small)};
` 
const USPItem = styled.div`
    color: ${EColor.FloralWhite};
    font-size: ${rem(20)};
    font-weight: 400;
    display: flex;
    align-items: center;
 
    min-width: 100%;
    
    margin: ${rem(ESize.small)} 0px;
    margin-left: ${rem(ESize.default)};
    ${breakPoint('md')` 
        margin: 0px 0px;
        margin-left: 0px;
        min-width: 0px;
    `}
`

export default function USPSection ({
    usps = []
}: {
    usps?: string[]
}) {
    
    return (
        <SectionWrapper background={EColor.ColombianBlue}>
            <ContentWrapper>
                <USPWrapper>
                    {usps.map((usp, index) => {
                        return (
                            <USPItem key={index}>
                                <Icon icon={EIconGlyph.check} size={ESize.default} color={EColor.SunglowYellow} />
                                <USPTitle>{usp}</USPTitle>
                            </USPItem>
                        )
                    })}
                </USPWrapper>
            </ContentWrapper>
        </SectionWrapper>
    )
}